 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Apply":"Apply","Applylist":"Applylist","Bhlist":"Bhlist","Buylist":"Buylist","Casting":"Casting","Castinglist":"Castinglist","Choosenft":"Choosenft","Collectionshop":"Collectionshop","Copyrightlist":"Copyrightlist","Createcollection":"Createcollection","Crosschainlist":"Crosschainlist","Crosschain~LpPlege~Nftdetail~Synthesis~Upinfo~newdetail":"Crosschain~LpPlege~Nftdetail~Synthesis~Upinfo~newdetail","Crosschain":"Crosschain","LpPlege":"LpPlege","Nftdetail":"Nftdetail","Synthesis":"Synthesis","Test~newdetail":"Test~newdetail","newdetail":"newdetail","Upinfo":"Upinfo","Exchange":"Exchange","Exchangelist":"Exchangelist","Globalnode":"Globalnode","Hashrate":"Hashrate","Home":"Home","Included":"Included","Introduce":"Introduce","Invite":"Invite","Jslist":"Jslist","Leaderboard":"Leaderboard","Lpfxlist":"Lpfxlist","Lpnode":"Lpnode","Lpsflist":"Lpsflist","Lpzylist":"Lpzylist","Minelists":"Minelists","Mints":"Mints","Mpquery":"Mpquery","My":"My","Myinfo":"Myinfo","Nftshop":"Nftshop","Nodedetail":"Nodedetail","Nodepush1":"Nodepush1","Nodepush2":"Nodepush2","Notice":"Notice","Pledge":"Pledge","Pledgedetail":"Pledgedetail","Pledgeitem":"Pledgeitem","Pledgelist":"Pledgelist","Question":"Question","Rankinglist":"Rankinglist","Receivelist":"Receivelist","Redemptionlist":"Redemptionlist","Search":"Search","Set":"Set","Sort":"Sort","Syntheticlist":"Syntheticlist","Test":"Test","new_more":"new_more"}[chunkId]||chunkId) + "." + {"Apply":"a16146ae","Applylist":"d993918d","Bhlist":"138f4ed6","Buylist":"1123dbe7","Casting":"f19a5f84","Castinglist":"032d9f35","Choosenft":"77ce238a","Collectionshop":"9bd1fb56","Copyrightlist":"ad860a58","Createcollection":"6f60fa3e","Crosschainlist":"164ff45c","Crosschain~LpPlege~Nftdetail~Synthesis~Upinfo~newdetail":"9a6fa67d","Crosschain":"704b98ab","LpPlege":"c171254e","Nftdetail":"c6945be7","Synthesis":"49b5e5fa","Test~newdetail":"08b09e6f","newdetail":"a0188f24","Upinfo":"eaf4f952","Exchange":"39719085","Exchangelist":"d61b8e9c","Globalnode":"1e97ff00","Hashrate":"1169117b","Home":"2794a897","Included":"304608ce","Introduce":"d9e6d210","Invite":"38ec6665","Jslist":"224fa2a3","Leaderboard":"7b9ad1d3","Lpfxlist":"b0b05a5f","Lpnode":"ca376ea9","Lpsflist":"253b2847","Lpzylist":"9f3b0dac","Minelists":"cec391c8","Mints":"1c1cde53","Mpquery":"4482cdaf","My":"1373b182","Myinfo":"0f259c9c","Nftshop":"be2e9b35","Nodedetail":"bc32b71c","Nodepush1":"b48e807a","Nodepush2":"912f56d5","Notice":"a89574c0","Pledge":"4f8a343c","Pledgedetail":"a4b3f6b3","Pledgeitem":"2f339d5f","Pledgelist":"58eaa7f8","Question":"91a79065","Rankinglist":"4e4e5ed1","Receivelist":"d713efb1","Redemptionlist":"32300531","Search":"606ac9d6","Set":"f62d6311","Sort":"9b6f16fc","Syntheticlist":"75cb8e06","Test":"92c9c5f2","new_more":"9668fa21"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Apply":1,"Applylist":1,"Bhlist":1,"Buylist":1,"Casting":1,"Castinglist":1,"Choosenft":1,"Collectionshop":1,"Copyrightlist":1,"Createcollection":1,"Crosschainlist":1,"Crosschain":1,"LpPlege":1,"Nftdetail":1,"Synthesis":1,"newdetail":1,"Upinfo":1,"Exchange":1,"Exchangelist":1,"Globalnode":1,"Hashrate":1,"Home":1,"Included":1,"Introduce":1,"Invite":1,"Jslist":1,"Leaderboard":1,"Lpfxlist":1,"Lpnode":1,"Lpsflist":1,"Lpzylist":1,"Minelists":1,"Mints":1,"Mpquery":1,"My":1,"Myinfo":1,"Nftshop":1,"Nodedetail":1,"Nodepush1":1,"Nodepush2":1,"Notice":1,"Pledge":1,"Pledgedetail":1,"Pledgeitem":1,"Pledgelist":1,"Question":1,"Rankinglist":1,"Receivelist":1,"Redemptionlist":1,"Search":1,"Set":1,"Sort":1,"Syntheticlist":1,"Test":1,"new_more":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Apply":"Apply","Applylist":"Applylist","Bhlist":"Bhlist","Buylist":"Buylist","Casting":"Casting","Castinglist":"Castinglist","Choosenft":"Choosenft","Collectionshop":"Collectionshop","Copyrightlist":"Copyrightlist","Createcollection":"Createcollection","Crosschainlist":"Crosschainlist","Crosschain~LpPlege~Nftdetail~Synthesis~Upinfo~newdetail":"Crosschain~LpPlege~Nftdetail~Synthesis~Upinfo~newdetail","Crosschain":"Crosschain","LpPlege":"LpPlege","Nftdetail":"Nftdetail","Synthesis":"Synthesis","Test~newdetail":"Test~newdetail","newdetail":"newdetail","Upinfo":"Upinfo","Exchange":"Exchange","Exchangelist":"Exchangelist","Globalnode":"Globalnode","Hashrate":"Hashrate","Home":"Home","Included":"Included","Introduce":"Introduce","Invite":"Invite","Jslist":"Jslist","Leaderboard":"Leaderboard","Lpfxlist":"Lpfxlist","Lpnode":"Lpnode","Lpsflist":"Lpsflist","Lpzylist":"Lpzylist","Minelists":"Minelists","Mints":"Mints","Mpquery":"Mpquery","My":"My","Myinfo":"Myinfo","Nftshop":"Nftshop","Nodedetail":"Nodedetail","Nodepush1":"Nodepush1","Nodepush2":"Nodepush2","Notice":"Notice","Pledge":"Pledge","Pledgedetail":"Pledgedetail","Pledgeitem":"Pledgeitem","Pledgelist":"Pledgelist","Question":"Question","Rankinglist":"Rankinglist","Receivelist":"Receivelist","Redemptionlist":"Redemptionlist","Search":"Search","Set":"Set","Sort":"Sort","Syntheticlist":"Syntheticlist","Test":"Test","new_more":"new_more"}[chunkId]||chunkId) + "." + {"Apply":"6a3dbd56","Applylist":"561b47a3","Bhlist":"20c401d0","Buylist":"4319ba3a","Casting":"a7e2af99","Castinglist":"95231cdc","Choosenft":"730e38a2","Collectionshop":"5d19e6c0","Copyrightlist":"ee74ee80","Createcollection":"592e1aa9","Crosschainlist":"5ff2c3f5","Crosschain~LpPlege~Nftdetail~Synthesis~Upinfo~newdetail":"31d6cfe0","Crosschain":"3900e1c4","LpPlege":"481ea30e","Nftdetail":"f8dd4cc4","Synthesis":"83b4a031","Test~newdetail":"31d6cfe0","newdetail":"257e1a12","Upinfo":"1a2a7215","Exchange":"a93b2e65","Exchangelist":"b9f912ce","Globalnode":"b471986d","Hashrate":"b0f9b888","Home":"fc7a13bb","Included":"2f86e121","Introduce":"afac2b22","Invite":"01e83102","Jslist":"2450e1cf","Leaderboard":"fcd6baf0","Lpfxlist":"2f713387","Lpnode":"91b4de3f","Lpsflist":"dcac13a5","Lpzylist":"b58418ac","Minelists":"89363fac","Mints":"b5ab905a","Mpquery":"58f75578","My":"c08bb9a3","Myinfo":"3968cc20","Nftshop":"63ca720f","Nodedetail":"3f91e136","Nodepush1":"d9e9b59f","Nodepush2":"f9acf915","Notice":"62162183","Pledge":"23c730ad","Pledgedetail":"ba402bdd","Pledgeitem":"0eb65643","Pledgelist":"ae8d1435","Question":"d4c2b0cb","Rankinglist":"1ea3819b","Receivelist":"1456dda7","Redemptionlist":"6200c33a","Search":"ef3ac457","Set":"dee045e7","Sort":"15cde404","Syntheticlist":"40b271cb","Test":"10a2409f","new_more":"70797b3b"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
